module.exports = __webpack_public_path__ + "static/media/lindab.900da9c7.png";